import { GetStaticProps, NextPage } from 'next';
import { Container, Row, Col } from 'reactstrap';
import { RichText, RichTextBlock } from 'prismic-reactjs';
import { Client } from '../utils';
import { Layout, SeoMeta } from '../components/Layout';
import { Section } from '../components/Sections';
import { ImageComponent } from '../components/Media';
import { List } from '../components/List';
import { Slider } from '../components/Slider';
import { Key } from 'react';
import { Accordion } from '../components/Accordion/accordion';

interface Props {
  content?: any;
}

const Residences: NextPage<Props> = ({ content }) => {
  return (
    <Layout>
      <SeoMeta
        title={RichText.asText(content.seo__title)}
        desc={RichText.asText(content.seo__description)}
        socialImage={content.seo__image}
      />
      <Section hasBottomMobile={false}>
        <Container fluid>
          <ImageComponent
            src="/collage-residences/collage-residences.png"
            alt="Collage"
            width={1400}
            height={1148}
            position="left"
            offset="left-full"
            mobileOffset
          />
        </Container>
      </Section>
      {content.introduction_text &&
        RichText.asText(content.introduction_text) !== '' && (
          <Section hasTop>
            <Container fluid>
              <Row>
                <Col
                  xs={7}
                  sm={4}
                  md={{ size: 5 }}
                  // lg={{ size: 6 }}
                >
                  <h1 className="font--xxl font--primary prevent-line-break">
                    {/* { RichText.asText(content.headline) } */}
                    Light. <br />
                    Space. <br />
                    Flexibility.
                  </h1>
                </Col>
                <Col
                  md={{
                    size: 6,
                    offset: 1,
                  }}
                  lg={{
                    size: 4,
                    offset: 3,
                  }}
                >
                  {RichText.render(content.introduction_text)}
                </Col>
              </Row>
            </Container>
          </Section>
        )}
      {content.slider && content.slider.length > 0 && (
        <Slider slides={content.slider} roundedImages size="xxl" hasBottom />
      )}

      <Section hasTop>
        <Container fluid>
          <h1 className="font--xxl font--primary prevent-line-break">
            {/* { RichText.asText(content.headline) } */}
            Stabilized Rents.
          </h1>
          <Accordion />
        </Container>
      </Section>
      {content.interior_text &&
        RichText.asText(content.interior_text) !== '' && (
          <Section>
            <Container fluid>
              <Row>
                <Col md={6} lg={6} xl={5}>
                  {RichText.render(content.interior_text)}
                </Col>
              </Row>
            </Container>
          </Section>
        )}
      {content.vimeo_videos && content.vimeo_videos.length > 0 && (
        <Section>
          <Container fluid>
            <Row>
              <Col xl={8}>
                <Row>
                  {content.vimeo_videos.map(
                    (
                      video: {
                        vimeo_video_id: string;
                        vimeo_video_title: any;
                        vimeo_hash_parameter: any;
                      },
                      key: Key | null | undefined
                    ) => {
                      if (!video.vimeo_video_id) {
                        return null;
                      }

                      return (
                        <Col md={6} key={key}>
                          <div className="vimeo-video">
                            <iframe
                              src={`https://player.vimeo.com/video/${video.vimeo_video_id}?h=${video.vimeo_hash_parameter}`}
                              allow="autoplay; fullscreen; picture-in-picture"
                              frameBorder="0"
                              title=""
                              allowFullScreen
                            ></iframe>
                          </div>
                          <h2 className="font--primary font--lg vimeo-video-title">
                            {RichText.asText(video.vimeo_video_title)}
                          </h2>
                        </Col>
                      );
                    }
                  )}
                </Row>
              </Col>
            </Row>
          </Container>
        </Section>
      )}
      {((content.bathroom_image_right && content.bathroom_image_right.url) ||
        (content.bathroom_image_left && content.bathroom_image_left.url)) && (
        <Section hasBottomMobile={false}>
          <Container fluid>
            <Row className="flex-column-reverse--sm">
              <Col md={4} className="flex flex--align-center">
                {content.bathroom_image_left &&
                  content.bathroom_image_left.url && (
                    <div className="full-width m-t-image--sm">
                      <ImageComponent
                        src={content.bathroom_image_left.url || ''}
                        alt={content.bathroom_image_left.alt || ''}
                        alignment="horizontal"
                        offset="left"
                      />
                    </div>
                  )}
              </Col>
              <Col md={{ size: 6, offset: 2 }}>
                {content.bathroom_image_right &&
                  content.bathroom_image_right.url && (
                    <div>
                      <ImageComponent
                        src={content.bathroom_image_right.url || ''}
                        alt={content.bathroom_image_right.alt || ''}
                        alignment="vertical"
                        offset="right"
                      />
                    </div>
                  )}
              </Col>
            </Row>
          </Container>
        </Section>
      )}
      {((content.apartment_finishes_headline &&
        RichText.asText(content.apartment_finishes_headline) !== '') ||
        (content.kitchen_image_left && content.kitchen_image_left.url) ||
        content.list.length > 0) && (
        <Section>
          <Container fluid>
            {((content.kitchen_image_left && content.kitchen_image_left.url) ||
              content.list.length > 0) && (
              <Row>
                {content.kitchen_image_left &&
                  content.kitchen_image_left.url && (
                    <Col xs={6} md={4}>
                      <div className="m-t-image--sm">
                        <ImageComponent
                          src={content.kitchen_image_left.url}
                          alt={content.kitchen_image_left.alt}
                          width={content.kitchen_image_left.dimensions.width}
                          height={content.kitchen_image_left.dimensions.height}
                          // alignment='vertical'
                          // offset='left'
                        />
                      </div>
                    </Col>
                  )}
                <Col md={{ size: 6, offset: 2 }}>
                  {content.list.length > 0 && (
                    <div className="m-t--sm">
                      {content.apartment_finishes_headline &&
                        RichText.asText(content.apartment_finishes_headline) !==
                          '' && (
                          <h3 className="font--xl font--primary">
                            {RichText.asText(
                              content.apartment_finishes_headline
                            )}
                          </h3>
                        )}
                      <div>
                        {content.list.map(
                          (
                            singleList: {
                              list__title: RichTextBlock[];
                              list__items: any;
                            },
                            index: Key | null | undefined
                          ) => {
                            return (
                              <List
                                key={index}
                                title={
                                  RichText.asText(singleList.list__title) || ''
                                }
                                items={singleList.list__items || []}
                              />
                            );
                          }
                        )}
                      </div>
                    </div>
                  )}
                </Col>
              </Row>
            )}
          </Container>
        </Section>
      )}
    </Layout>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  // https://prismic.io/docs/technologies/query-by-type-rest-api
  const res = await Client.query('[at(document.type, "residences")]');
  const data = res.results.map((content: { data: any }) => {
    return content.data;
  });
  const content = data[0];

  return {
    props: {
      content,
    },
  };
};

export default Residences;
